<template>
  <v-data-table
    :headers="route_headers"
    :items="route_items"
    loading-text="Загружаю данные"
    class="elevation-1 mt-3"
    dense
    :footer-props="{
      itemsPerPageText: 'На страницу',
      itemsPerPageAllText: 'Все',
      pageText: 'из'
    }"
  >
    <template v-slot:top>
      <v-system-bar color="primary" dark>
        <span class="white--text">История состояний:</span>
      </v-system-bar>
    </template>
    <template v-slot:no-data>
      Нет данных
    </template>
  </v-data-table>
</template>

<script>
import { RCPT_GET_ROUTE } from '@/store/actions/receptures'
import { UI_SNACKBAR } from '@/store/actions/ui'
export default {
  name: 'tblProjectRoute',
  props: {
    project: {
      type: Object,
      default () {
        return { }
      }
    }
  },
  data () {
    return {
      route_headers: [
        { text: 'Дата', align: 'start', sortable: false, value: 'SIGN_DATE' },
        { text: 'Из статуса', value: 'OLD_STATE_NAME', sortable: true },
        { text: 'В статус', value: 'NEW_STATE_NAME' },
        { text: 'Пользователь', value: 'USR_FIO' },
        { text: 'Подразделение', value: 'DEPT_NAME', sortable: false }
      ],
      route_items: []
    }
  },
  watch: {
    project () {
      this.getData()
    }
  },
  methods: {
    getData () {
      console.log('Getting route data for project ', this.project)
      this.route_items.splice(0, this.route_items.length)
      this.$store.dispatch(RCPT_GET_ROUTE, { ULF_UUID: this.project.ULF_UUID })
        .then((resp) => {
          this.route_items = resp
        })
        .catch((err) => {
          this.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: 'Ошибка загрузки данных:' + err })
        })
    }
  },
  mounted: function () {
    this.getData()
  }
}
</script>

<style scoped>

</style>
